import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { MessageNotificationButtonService } from './message-notification-button.service';

import { Notification } from '../message-notification-button/notification';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatIconButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';
import { MatBadge } from '@angular/material/badge';
import { RouterLink } from '@angular/router';
import { AvatarComponent } from '../../../../../shared/components/avatar/avatar.component';

@Component({
  selector: 'app-message-notification-button',
  templateUrl: './message-notification-button.component.html',
  styleUrl: './message-notification-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [
    MatProgressSpinner,
    MatIconButton,
    MatMenuTrigger,
    MatIcon,
    MatBadge,
    MatMenu,
    MatMenuItem,
    RouterLink,
    AvatarComponent,
  ],
})
export class MessageNotificationButtonComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  messageNotificationButtonService = inject(MessageNotificationButtonService);

  readonly totalChatNotifications = toSignal(this.messageNotificationButtonService.totalChatNotifications, {
    requireSync: true,
  });
  public notifications: Notification[];

  ngOnInit(): void {
    this.messageNotificationButtonService.notifications
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((notifications) => {
        // Set the notifications immediately, so they appear to the user as soon as possible
        this.notifications = notifications;
        // Attempt to retrieve additional data
        void this.populateMissingPatientDetails();
      });
  }

  /**
   * If there is no email address associated with the user, fetch that user's name and email address from the server
   * @private
   */
  private async populateMissingPatientDetails(): Promise<void> {
    for (const notification of this.notifications) {
      // All patients should have an email address - if they do not, then we do not have any of their details
      if (!notification.patient.email) {
        const patientDetails = await this.messageNotificationButtonService.getPatientDetails(
          notification.chatSessionId
        );
        notification.patient.email = patientDetails.email;
        notification.patient.name = patientDetails.name;
      }
    }
  }
}
